module.exports = __webpack_public_path__ + "assets/fcdc4b53db6ed6ac765907f4bbd5fbdd.png";